import A12Y_CONST from '../common/a12yConst';

export const getCustomCategoryErrorMessage = (error) => {
    const data = error?.response?.data || error;
    if (data?.sr?.error?.code === '23505') {
        if (data?.sr?.error?.table === 'a12y_doctor_speciality') {
            return 'Specialty already exists.';
        }
        return 'A category with this name already exists.';
    }
    if (data?.sr?.a12yErr?.message) {
        return data.sr.a12yErr.message;
    }
    if (error?.message) {
        return error.message;
    }
    return A12Y_CONST.ERROR_MESSAGE.UNEXPECTED_ERROR_MSG || 'Something went wrong.';
};
